import { TbArrowLeft, TbDots } from "react-icons/tb";
import CarePlusStepper from "./CarePlusStepper";

interface Props {
  current: "treatment" | "plan" | "checkout";
  t: (key: string, fallback: string) => string;
  onBack: () => void;
}

// The Care+ funnel progress bar (Shipping, WL reorder): compact with back arrow on small screens.
const CarePlusStepperHeader = ({ current, t, onBack }: Props) => (
  <>
    <div className="mt-0 mb-[30px] flex w-full items-center justify-between md:hidden">
      <button onClick={onBack} className="flex size-[44px] shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-0">
        <TbArrowLeft size={22} className="text-[#5b5b5b]" />
      </button>
      <div className="flex min-w-0 flex-1 items-center justify-center px-[16px]">
        <div className="w-full min-w-0 max-w-[335px]">
          <CarePlusStepper current={current} t={t} compact />
        </div>
      </div>
      <div className="flex size-[44px] shrink-0 items-center justify-center">
        <TbDots size={22} className="text-[#9ca8b8]" />
      </div>
    </div>
    <div className="mt-0 mb-[30px] hidden w-full justify-center md:flex">
      <div className="w-full max-w-[460px]">
        <CarePlusStepper current={current} t={t} />
      </div>
    </div>
  </>
);

export default CarePlusStepperHeader;
